import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Form, Field } from "react-final-form";
import { useTranslate } from "lib/translate";
import BlockAssessments from "components/BlockAssessments";
import { Button, Expandable } from '@haldor/ui';

var KnowledgeRequirements = function KnowledgeRequirements(props) {
  var translate = useTranslate();
  var section = useSelector(function (state) {
    return state.sections.activeSection;
  });
  var activeAssignment = useSelector(function (state) {
    return state.assignments.active_assignment;
  });
  var details = useSelector(function (state) {
    return state.assignments.teamsAssignmentDetails;
  });
  var blocks = useSelector(function (state) {
    return state.Blocks.reference;
  });

  var initialValues = _objectSpread(_objectSpread({
    assessmentBlocks: blocks === null || blocks === void 0 ? void 0 : blocks.filter(function (block) {
      return block.type == 'Haldor.Blocks.AssessmentBlock';
    })
  }, activeAssignment), details);

  var submit = function submit(values) {
    return new Promise(function (resolve) {
      var assignment = null;

      if (values.id === parseInt(values.id, 10)) {
        assignment = values;
      } else {
        assignment = {
          externalId: values.id,
          origin: "TEAMS",
          title: values.displayName,
          dueDate: values.dueDateTime,
          description: values.instructions.content,
          sectionId: section.id,
          assessmentBlocks: values.assessmentBlocks
        };
      } // Edit values here before posting them to the parent component


      if (props.onSubmit != null) {
        props.onSubmit(assignment).then(function () {
          resolve(assignment);
        });
      }
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "form-container"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: submit,
    initialValues: initialValues,
    render: function render(_ref) {
      var handleSubmit = _ref.handleSubmit,
          submitting = _ref.submitting;
      return /*#__PURE__*/React.createElement(Fragment, null, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending",
        style: {
          height: "100%"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: "absolute"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: "form form-component"
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: translate('Assessments'),
        open: true,
        ignorePropsUpdate: true
      }, /*#__PURE__*/React.createElement(Field, {
        component: BlockAssessments,
        name: "assessmentBlocks"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, null, translate("save-knowledge-requirements")), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    }
  }));
};

export default KnowledgeRequirements;